// Keep the mounted application reference independent of route and component imports.
export default { current: null }
